import { parseInlineCookies } from '../cookies'
import { ParseError } from '../errors'
import { type AccountData, emptyAccount } from '../models'

export function splitWebCookiesRecords(data: string): string[] {
  return data
    .trim()
    .split('\n')
    .map((l) => l.trim())
    .filter((l) => l.length > 0)
}

export function canParseWebCookies(data: string): boolean {
  for (const raw of data.trim().split('\n')) {
    const line = raw.trim()
    if (!line) continue
    if (!line.includes('[') || !line.includes(']')) continue
    const before = line.split('[')[0]
    if ((before.match(/:/g) ?? []).length >= 2) return true
  }
  return false
}

export function parseWebCookies(record: string): AccountData {
  const r = record.trim()
  if (!r.includes('[') || !r.includes(']')) {
    throw new ParseError('Missing bracket-enclosed cookies')
  }

  const openIdx = r.indexOf('[')
  const closeIdx = r.lastIndexOf(']')
  const loginPart = r.slice(0, openIdx)
  const cookiesPart = r.slice(openIdx + 1, closeIdx)

  const lp = loginPart.split(':')
  if (lp.length !== 3) {
    throw new ParseError(`Expected login:pass:2FA, got ${loginPart}`)
  }
  const [login, password, twofaKey] = lp
  const cookies = parseInlineCookies(cookiesPart)

  if (!('sessionid' in cookies) || !('ds_user_id' in cookies)) {
    throw new ParseError('Missing required cookies: sessionid, ds_user_id')
  }

  return { ...emptyAccount(), login, password, twofaKey, cookies }
}
